import {Component, OnInit, ViewChild, AfterViewInit, ViewChildren, QueryList} from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { TableroNegocioService, TABLERO } from '../../../../services/tablero-negocios-service';
import { ChartOptions, ChartType, ChartDataSets, MultiDataSet } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { PricePipe } from '../../../../utils/pipes/price';


@Component({
  selector: 'app-expanded-chart-dialog',
  templateUrl: './expanded-chart-dialog.component.html',
  styleUrls: ['./expanded-chart-dialog.component.scss']
})
export class ExpandedChartDialogComponent implements OnInit, AfterViewInit {

  constructor(public dialogRef: MdDialogRef<ExpandedChartDialogComponent>,
              private tableroService: TableroNegocioService,
              private pricePipe: PricePipe) { }

   /**
    Este chart es generico, construir el grafico con el metodo buildChart
    antes de la declaracion esta el objeto comentado.
    la variable importada TABLERO contiene un enumerador de todos los chart que requieren este dialogo.
   **/

  public chart = '';
  public filter = {};
  private finalFilter: any;
  public dialogTitle = '';
  public chartIsVertical = false;
  private chartIsReady = false;
  private chartHasError = false;
  private chartErrorMessage = '';
  private chartErrors = {
    error: 'Lo sentimos, la información solicitada no pudo ser procesada. Por favor, intente nuevamente.',
    noValues: 'No se encontraron valores con los filtros aplicados.'
  };
  @ViewChild(BaseChartDirective) charts: BaseChartDirective;

  private genericColors = [
    {backgroundColor: []},
    {backgroundColor: []},
    {backgroundColor: []}
  ];

  private chartOptions: ChartOptions = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          callback: function(t) {
            const maxLabelLength = 15;
            if (t.length > maxLabelLength) {
              return t.substring(0, maxLabelLength) + '...';
            } else {
              return t;
            }
          }
        }}],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: true,
          drawBorder: true
        },
        ticks: {
          beginAtZero: true,
          callback: function(value, index, values) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }] },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.yLabel, 'clamp');
        }),
        footer: ((tooltipItems, data) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].yLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  private chartLabels = [];
  private chartType: ChartType = 'bar';
  private chartLegend = false;
  private chartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' }
  ];

  private horizontalChartOptions: ChartOptions = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true,
        position: 'top',
        gridLines: {
          display: true,
          drawBorder: true
        },
        ticks: {
          beginAtZero: true,
          fontColor: '#565656',
          maxTicksLimit: 10,
          callback: function(value, index, values) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          }
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: false,
          drawBorder: true
        },
        ticks: {
          fontColor: '#565656',
          callback: function (t) {
            const maxLabelLength = 10;
            if (t.length > maxLabelLength) {
              return t.substring(0, maxLabelLength) + '...';
            } else {
              return t;
            }
          }
        }
      }]
    },
    tooltips: {
      intersect : false,
      mode: 'index',
      callbacks: {
        title: function(t, d) {
          return d.labels[t[0].index];
        },
        label: ((tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          return label + this.pricePipe.transform(tooltipItem.xLabel, 'clamp');
        }),
        footer: ((tooltipItems, data) => {
          let total = 0;
          for (let i = 0; i < tooltipItems.length; i++) {
            total += parseFloat(tooltipItems[i].xLabel);
          }
          return 'Total: ' + this.pricePipe.transform(total, 'clamp');
        })
      }
    }
  };
  private horizontalChartLabels = [];
  private horizontalChartType: ChartType = 'horizontalBar';
  private horizontalChartLegend = false;
  private horizontalChartData: ChartDataSets[] = [
    { data: [], label: 'Oportunidades', stack: 'a' },
    { data: [], label: 'Comprometidas', stack: 'a' },
    { data: [], label: 'Finalizadas', stack: 'a' }
  ];

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.finalFilter = this.buildFilter(this.filter);
    this.loadData();
  }

  loadData() {
    this.chartIsReady = false;
    this.chartHasError = false;
    switch (this.chart) {
      case TABLERO.DASH_COSECHA:
        this.dialogTitle = 'COSECHAS';
        this.loadCosecha();
        break;
      case TABLERO.DASH_ACOPIOS:
        this.dialogTitle = 'ACOPIOS';
        this.loadAcopio();
        break;
      case TABLERO.DASH_ENTREGA:
        this.dialogTitle = 'ENTREGAS';
        this.loadEntrega();
        break;
      case TABLERO.DASH_CLIENTE:
        this.dialogTitle = 'CLIENTES';
        this.loadCliente();
        break;
      default:
        this.closeDialog();
        break;
    }
  }

  loadCosecha() {
    this.tableroService.getDashCosecha(this.finalFilter)
      .subscribe(data => {
        if (data) {
          const dataArray = [];
          data.forEach(item => {
            dataArray.push({comprometidas: item.Comprometidas, oportunidades: item.Oportunidades, finalizadas: item.Finalizadas, label: item.Cosecha.toString()});
          });
          if (dataArray.length) {
            this.buildChart(dataArray);
          } else {
            this.setError(this.chartErrors.noValues);
          }

        }
      }, (err) => {
        this.setError(this.chartErrors.error);
        });
  }

  loadAcopio() {
    this.tableroService.getDashAcopio(this.finalFilter)
      .subscribe(data => {
        if (data) {
          const dataArray = [];
          data.forEach(item => {
            dataArray.push({comprometidas: item.Comprometidas, oportunidades: item.Oportunidades, finalizadas: item.Finalizadas, label: item.Acopio.toString()});
          });
          if (dataArray.length) {
            this.buildChart(dataArray);
          } else {
            this.setError(this.chartErrors.noValues);
          }

        }
      }, (err) => {
        this.setError(this.chartErrors.error);
      });
  }

  loadEntrega() {
    this.tableroService.getDashEntrega(this.finalFilter)
      .subscribe(data => {
        if (data) {
          const dataArray = [];
          data.forEach(item => {
            dataArray.push({comprometidas: item.Comprometidas, oportunidades: item.Oportunidades, finalizadas: item.Finalizadas, label: item.TipoPosicion.charAt(0).toUpperCase() + item.TipoPosicion.slice(1)});
          });
          if (dataArray.length) {
            this.buildChart(dataArray);
          } else {
            this.setError(this.chartErrors.noValues);
          }

        }
      }, (err) => {
        this.setError(this.chartErrors.error);
      });
  }

  loadCliente() {
    this.tableroService.getDashClientes(this.finalFilter)
      .subscribe(data => {
        if (data) {
          const dataArray = [];
          data.forEach(item => {
            dataArray.push({comprometidas: item.Comprometidas, oportunidades: item.Oportunidades, finalizadas: item.Finalizadas, label: item.Cliente});
          });
          if (dataArray.length) {
            this.buildChart(dataArray);
          } else {
            this.setError(this.chartErrors.noValues);
          }

        }
      }, (err) => {
        this.setError(this.chartErrors.error);
      });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  /**
  data = [{
    confirmadas: number,
    oportunidades: number,
    label: string,             - el label inferior de cada columna
  }]
   **/

  buildChart(data) {
    if (data.length) {

      if (this.chartIsVertical) {

        this.chartLabels.length = 0;
        data.forEach(item => {
          this.chartLabels.push(item.label);
          this.chartData[0].data.push(item.oportunidades);
          this.chartData[1].data.push(item.comprometidas);
          this.chartData[2].data.push(item.finalizadas);
          this.genericColors[0].backgroundColor.push('rgba(58, 129, 245, 0.75)');
          this.genericColors[1].backgroundColor.push('rgba(75, 176, 138, 0.75)');
          this.genericColors[2].backgroundColor.push('rgba(0, 126, 4, 0.75)');
        });
        this.chartIsReady = true;
        setTimeout(_ => {
          let width = 0;
          if (this.chartLabels.length <= 4) {
            width = 750;
          } else if (this.chartLabels.length <= 20) {
            width = 1000;
          } else {
            width = 100 + (50 * this.chartLabels.length);
          }
          this.charts.chart.canvas.parentNode.style.width = width.toString() + 'px';
          this.charts.chart.resize();
        });

      } else {

        this.horizontalChartLabels.length = 0;
        data.forEach(item => {
          this.horizontalChartLabels.push(item.label);
          this.horizontalChartData[0].data.push(item.oportunidades);
          this.horizontalChartData[1].data.push(item.comprometidas);
          this.horizontalChartData[2].data.push(item.finalizadas);
          this.genericColors[0].backgroundColor.push('rgba(58, 129, 245, 0.75)');
          this.genericColors[1].backgroundColor.push('rgba(75, 176, 138, 0.75)');
          this.genericColors[2].backgroundColor.push('rgba(0, 126, 4, 0.75)');
        });
        this.chartIsReady = true;
        setTimeout(_ => {
          let height = 0;
          if (this.horizontalChartLabels.length <= 8) {
            height = 500;
            this.charts.chart.options.scales.xAxes[0].position = 'bottom';
          } else {
            height = 100 + (50 * this.horizontalChartLabels.length);
          }
          this.charts.chart.canvas.parentNode.style.width = '1000px';
          this.charts.chart.canvas.parentNode.style.height = height.toString() + 'px';

          this.charts.chart.resize();
        });
      }
    }
  }

  buildFilter(filter) {
    const object = {};
    Object.keys(filter).forEach(key => {
      object[key] = filter[key];
    });
    object['ResultSize'] = 500;
    return object;
  }

  setError(message: string) {
    this.chartHasError = true;
    this.chartErrorMessage = message;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/tablero-negocios/expanded-chart-dialog/expanded-chart-dialog.component.ts